import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { type PropsWithChildren, useMemo } from 'react'

import { isTestMode } from '@utils/env.ts'
import { ProblemDetailsError } from '@utils/errors.ts'

const STATUS_CODE_RETRY_BLACKLIST = [400, 401, 403, 404, 409]

function shouldRetry(numberOfTries: number, error: unknown) {
  // disallow retries in testing mode
  if (isTestMode && numberOfTries >= 1) return false

  if (error instanceof ProblemDetailsError && STATUS_CODE_RETRY_BLACKLIST.includes(error.status)) {
    return false
  }

  return numberOfTries < 3
}

function CustomQueryClientProvider(props: PropsWithChildren) {
  const client = useMemo(() => {
    return new QueryClient(
      {
        defaultOptions: {
          queries: {
            retry: shouldRetry,
          },
        },
      }
    )
  }, [])

  return (
    <QueryClientProvider client={client}>
      {props.children}
    </QueryClientProvider>
  )
}

export default CustomQueryClientProvider